import { Component,  Input } from '@angular/core';
import { publicHelpers } from './../../helpers/public-helpers';
import { Performer } from 'globals/store/performers.data';
import { TextNoTextComponent } from '../misc/text-no-text.component';
import { CommonModule } from '@angular/common';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { PhotoComponent } from '../photo';

@Component({
    selector: 'performer-profile',
    template: `
<div class="performer-box">
  <div class="performer-pics">
    <photo [data]="{photoURL: performer.photoUrl, title: performer.name }" [size]="120"></photo>
    <img class="logo" *ngIf="!!performer.logoUrl" [src]="performer.logoUrl" />
    <div *ngIf="!performer.logoUrl" class="empty-logo">LOGO</div>
  </div>
  <div class="performer-info">
    <div class="bold-text">{{ performer.name }}</div>
    <text-no-text [text]="performer.line1" [placeholder]="'Line 1'"></text-no-text>
    <text-no-text [text]="performer.line2" [placeholder]="'Line 2'"></text-no-text>
    <div class="spacer"></div>
    <a *ngIf="performer.email" class="secondary_link performer-email" href="mailto:{{performer.email}}">{{performer.email}}</a>

    <text-no-text [text]="performer.phone"></text-no-text>
    <div class="spacer"></div>
    <social-links *ngIf="performer?.social?.length" [socialLinks]="performer.social"></social-links>
  </div>
</div>
<hr />
<text-no-text [greyTitle]="'BIO'" [text]="performer.bio" [placeholder]="'Performer bio'"></text-no-text>
  `,
    styleUrls: ['./performerProfile.scss', './managePerformer.dialog.scss'],
    standalone: true,
    imports: [TextNoTextComponent, CommonModule, SocialLinksComponent, PhotoComponent]
})
export class PerformerProfileComponent {
  publicHelpers = publicHelpers
  @Input() performer: Performer
}